import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import auth from "../services/auth";
/**
 * HOC that Handles whether or not the user is allowed to see the page.
 * @param {array} allowedRoles - user roles that are allowed to see the page.
 * @returns {Component}
 */

export default function Authorization(allowedRoles) {
  return WrappedComponent => {
    const WithAuthorization = () => {
      const user = auth.getUserInfo();
      if (user !== null) {
        if (allowedRoles.includes(user.userTypeName) || [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(localStorage.getItem('userTypeID'))) == false) {
          return <WrappedComponent {...user} />;
        }
        return <h1>No page for you!</h1>; // Redirect actually
      }
      return null;
    };
    function mapStateToProps() {
      const user = auth.getUserInfo();
      return {
        user
      };
    }
    WithAuthorization.propTypes = {
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        userTypeName: PropTypes.string.isRequired
      })
    };
    return connect(mapStateToProps)(WithAuthorization);
  };
}



// WEBPACK FOOTER //
// ./src/app/routes/Authorization.js